import { Injectable } from '@angular/core';
import { AlertService } from './alert/alert.service';
import { HttpClient } from "@angular/common/http";
import { Router } from '@angular/router';

export let signinGlobalVariables: Object = {
  isDev: String(window.location).match(/4200|-dev/) !== null,
  additional_parameters: ''
};


@Injectable({
  providedIn: 'root',
})

export class SigninGeneralService {
  result = false;
  public capsLock = false;

  constructor(private httpClient: HttpClient, private alertService: AlertService, private router: Router) {
  }

  sendPasswordReset(id: string, email: string, workGroupId: string, showMsgToUser: boolean) {
    this.httpClient.post<string[]>('tools/save_data', {
      table: 'users',
      type: 'force_password_change',
      id: id,
      new_data: true,
      resetPassword: true,
      email: email,
      workgroup: workGroupId
    }).subscribe({next: (ans: any) => {
        let msg: string;
        let short_msg: string;
        if (ans['ok']) {
          msg = 'An email with password reset instructions was sent.';
          short_msg = showMsgToUser ? 'Please check your inbox and follow the instructions.' : '';
        } else {
          msg = 'Error has happened';
          short_msg = ans['error'];
        }
        this.alertService.popupOKOnly(msg, short_msg, 'Press any key to continue.').
          subscribe(() => {
            if (showMsgToUser) {
              this.back_to_login(3000, false);
            }
          });
      }});
  }

  back_to_login(timeout: number, delete_cookies: boolean) {
    if (delete_cookies) {
      this.httpClient.post<string[]>('aauth/delete_cookies',{}).subscribe();
    }
    setTimeout(() => {
      return this.router.navigate(['/a']);
    }, timeout);
  }

  signin_set_additional_parameters(additional_parameters: string = null) {
    if (additional_parameters !== undefined && additional_parameters !== null && additional_parameters.length > 5 &&
        additional_parameters.indexOf('?') > -1) {
      signinGlobalVariables['additional_parameters'] = '?' + additional_parameters.split('?')[1];
    } else {
      signinGlobalVariables['additional_parameters'] = '';
    }
  }
}



